import { combineReducers } from "redux";
import dashboardReducer from "./DashboardReducer/DashboardReducer";
import loginReducer from "./LoginReducer/LoginReducer";
import commonReducer from "./CommonReducer/CommonReducer";
import adminPPReducer from './AdminPPReducer/AdminPPReducer';
import hospitalReducer from './HospitalReducer/HospitalReducer';
import patientReducer from './PatientReducer/PatientReducer';
import structureReducer from './StrutureReducer/StructureReducer';
import retailReducer from "./RetailReducer/RetailReducer";
import calendarReducer from './CalendarReducer/CalendarReducer';
import planTherapeuticReducer from './PlanTherapeuticReducer/PlanTherapeuticReducer';
import eventAllergiesReducer from './EventAllergie/EventAllergie';
import allergiesReducer from "./AllergyIntolerance/AllergyIntolerance";
import attachmentAnalysisReducer from "./AttachmentAnalysis/AttachmentAnalysis"
import drugsReducer from "./DrugsReducer.jsx/DrugsReducer"
const reducers = combineReducers({
    loginReducer: loginReducer,
    dashboardReducer: dashboardReducer,
    commonReducer:commonReducer,
    adminPPReducer:adminPPReducer,
    hospitalReducer:hospitalReducer,
    patientReducer:patientReducer,
    structureReducer:structureReducer,
    retailReducer:retailReducer,
    calendarReducer:calendarReducer,
    planTherapeuticReducer:planTherapeuticReducer,
    eventAllergiesReducer:eventAllergiesReducer,
    allergiesReducer:allergiesReducer,
    attachmentAnalysisReducer:attachmentAnalysisReducer,
    drugsReducer:drugsReducer
});

export default reducers;
// export type RootState = ReturnType<typeof reducers>;